import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=01793dda&scoped=true&lang=pug&"
import script from "./CaseForm.vue?vue&type=script&lang=js&"
export * from "./CaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseForm.vue?vue&type=style&index=0&id=01793dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01793dda",
  null
  
)

export default component.exports